import { createFusionAtom } from '@exodus/fusion-atoms';
const createShareActivityAtom = ({ fusion }) => createFusionAtom({
    fusion,
    path: 'shareActivity',
    defaultValue: true,
});
const shareActivityAtomDefinition = {
    id: 'shareActivityAtom',
    type: 'atom',
    factory: createShareActivityAtom,
    dependencies: ['fusion'],
    public: true,
};
export default shareActivityAtomDefinition;
